import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { HttpService } from '../../services/http.service';
import { IPrice } from '../../interfaces/price.interface';
import { AppointmentStepperService } from '../../services/appointment-stepper.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-discover-pathway',
  templateUrl: './discover-pathway.component.html',
  standalone: true,
  imports: [TranslateModule, NzIconModule, NzDividerModule, CommonModule],
  styleUrls: ['./discover-pathway.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DiscoverPathwayComponent implements OnInit {
  visitType?: string | null;
  priceInfo?: IPrice;
  sodType?: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpService,
    private appointmentStepperService: AppointmentStepperService
  ) {}

  ngOnInit() {
    this.visitType = this.route.snapshot.queryParamMap.get('id');
    if (this.visitType === 'SpecialistTelevisitVideoPayment' || this.visitType === 'GenericTelevisitVideoPayment') {
      localStorage.setItem('consultType', this.visitType);
    }
    this.sodType = this.handleSodType();
    this.http.quotation(this.sodType).subscribe((res) => {
      this.priceInfo = res;
      localStorage.setItem('price', res?.netto)
    });
  }

  protected buy(): void {
    this.router.navigate(['/medical-consultations/discover-care-pathway'], { state: { sodType: this.sodType } });
  }

  protected back(): void {
    this.router.navigate(['/medical-consultations']);
  }

  private handleSodType(): number {
    switch (this.visitType) {
      case 'TreatmentPathPsiTelevisitFU': {
        this.appointmentStepperService.setSpecialistData(
          new FormGroup({
            specialistType: new FormControl({ description: 'Psicologo', id: 6 }, [Validators.required]),
          })
        );
        return 2;
      }
      case 'TreatmentPathNutTelevisitFU': {
        this.appointmentStepperService.setSpecialistData(
          new FormGroup({
            specialistType: new FormControl({ description: 'Nutrizionista', id: 5 }, [Validators.required]),
          })
        );
        return 3;
      }
      case 'SpecialistTelevisitVideoPayment': {
        return 1;
      }
      default:
        return 0;
    }
  }
}
